class PageController {
  constructor({ onEnter = () => {}, onLeave = () => {} }) {
    this.onEnter = onEnter;
    this.onLeave = onLeave;
  }

  enter() {
    this.onEnter();
  }

  leave() {
    this.onLeave();
  }
}

export function createPageControllers(pageLifecycles) {
  return Object.fromEntries(
    Object.entries(pageLifecycles).map(([page, lifecycle]) => [
      page,
      new PageController(lifecycle),
    ])
  );
}
